import './styles.scss'

const CardNewsSkeleton = () => {
  return (
    <article className="card-news-skeleton">
      <div className="card-news-skeleton__image" />

      <div className="card-news-skeleton__content">
        <div className="card-news-skeleton__title" />
        <div className="card-news-skeleton__title short" />

        <div className="card-news-skeleton__description" />
        <div className="card-news-skeleton__description" />
        <div className="card-news-skeleton__description short" />
      </div>
    </article>
  )
}

export default CardNewsSkeleton
